var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeSki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.7,
    cy: 21.9,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.8,39.5l-1.9,1.9c3,3,3,7.8,0,10.8L97.8,83.3V30.8c0-5.7-4.7-10.4-10.4-10.4v2.7c4.2,0,7.6,3.4,7.6,7.6v4.1H46.5 L20,8.4c-2-2-5.3-2-7.3,0s-2,5.3,0,7.3L15,18v59.2h2.7V20.7l21.5,21.5v40.5L59,62.9V45.2h36v33.7L76.3,60.1c-2-2-5.3-2-7.3,0 L41.8,87.3c2.3,2.3,5.2,3.4,8.2,3.4h40.5l-35.7,35.7l1.9,1.9l38.4-38.4v46.4h2.7V87.2l33-33C134.8,50.1,134.8,43.5,130.8,39.5z  M63.2,80.4l9.4-9.4l9.4,9.4H63.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeSki);
export default __webpack_public_path__ + "static/media/freeSki.dfd19491751362c8b8ed0164416f7860.svg";
export { ForwardRef as ReactComponent };